import { BlocksAccordion } from 'blocks-nextjs/blocks-web-components/components/accordion/accordion';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatAccordion = createComponent({
    react: React,
    tagName: 'cat-accordion',
    elementClass: BlocksAccordion,
    events: {
        onBlAccordionOpen: 'bl-accordion-open',
        onBlAccordionClose: 'bl-accordion-close'
    }
});
